import { images } from '../constants';
 
const services = [  
    {
        id: 1,
        image: images.service1, 
        title: 'Lawn Maintenance',
        content: 'Maintaining and caring for lawns, including mowing, edging, and fertilizing.',
        paragraphs: [
            'A well-maintained lawn not only boosts the curb appeal of your home but also provides a relaxing space for you and your family to enjoy. Our expert lawn maintenance services ensure your lawn stays healthy, green, and perfectly manicured throughout the year.',
            'We offer a comprehensive range of services, including mowing, edging, fertilizing, aeration, and weed control. With our dedicated team and advanced equipment, we make sure your lawn remains a lush and vibrant part of your landscape.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: {
            intro: 'Discover why our lawn maintenance services are the best choice for your outdoor space.',
            list: [
                'Time-saving and hassle-free services',
                'Expert care for a lush, green lawn',
                'Custom solutions tailored to your lawn’s needs',
                'Eco-friendly and sustainable practices',
                'Increases the overall value of your property'
            ]
        },
        process: {
            intro: 'Our streamlined process ensures efficient and top-quality results every time.',
            list: [
                'Initial assessment to understand your lawn’s needs',
                'Customized lawn care plan creation',
                'Regular maintenance visits for mowing, trimming, and cleanup',
                'Seasonal treatments such as fertilization and aeration',
                'Continuous monitoring and adjustments for optimal lawn health'
            ]
        },
        faqs: [
            {
                id: 1,
                heading: 'How do we determine pricing for lawn maintenance?',
                content: 'Our pricing depends on factors like the size of your lawn, the services required, and the frequency of maintenance. Contact us for a detailed and personalized quote.'
            },
            {
                id: 2,
                heading: 'Do you offer organic lawn care options?',
                content: 'Yes, we offer eco-friendly and organic lawn care solutions that prioritize the health of your lawn and the environment.'
            },
            {
                id: 3,
                heading: 'What areas do you serve?',
                content: 'We provide lawn maintenance services across [Your Service Area]. Please contact us to confirm if we serve your location.'
            },
            {
                id: 4,
                heading: 'Can we customize our lawn maintenance plan?',
                content: 'Absolutely! Our plans are fully customizable to meet the unique needs of your lawn. We’ll work with you to design a plan that fits your preferences and budget.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2, 
        title: 'Garden Design',
        content: 'Designing beautiful and functional garden layouts tailored to your preferences.',
        paragraphs: [
            'A thoughtfully designed garden can elevate the aesthetic appeal of your property and provide a peaceful retreat for relaxation. Our expert garden designers blend creativity, functionality, and sustainability to craft outdoor spaces that perfectly reflect your vision.',
            'From conceptual planning to final implementation, we collaborate with you at every step to ensure your garden design exceeds expectations. Whether you prefer modern minimalism or lush, traditional gardens, we bring your dream to life with meticulous attention to detail.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: {
            intro: 'Why choose our garden design services?',
            list: [
                'Tailored designs to suit your preferences',
                'Expert team with years of experience',
                'Eco-friendly and sustainable practices',
                'High-quality materials and plants',
                'Maximizes functionality and aesthetic appeal'
            ]
        },
        process: {
            intro: 'Our step-by-step process ensures a seamless experience.',
            list: [
                'Initial consultation to understand your vision',
                'Site assessment and design planning',
                'Detailed garden layout and material selection',
                'Professional execution and installation',
                'Post-installation support and guidance'
            ]
        },
        faqs: [
            {
                id: 1,
                heading: 'What is included in your garden design service?',
                content: 'Our service includes initial consultation, design planning, material selection, plant placement, and full installation to create a stunning garden tailored to your needs.'
            },
            {
                id: 2,
                heading: 'Can you work with small spaces?',
                content: 'Absolutely! We specialize in designing beautiful gardens for spaces of all sizes, ensuring maximum functionality and charm, even in compact areas.'
            },
            {
                id: 3,
                heading: 'Do you use eco-friendly materials and plants?',
                content: 'Yes, we prioritize sustainability by using eco-friendly materials and native plants that thrive in your local environment.'
            },
            {
                id: 4,
                heading: 'How long does the garden design process take?',
                content: 'The timeline depends on the size and complexity of the project. During the consultation, we’ll provide you with an estimated timeframe.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3, 
        title: 'Tree Planting',
        content: 'Planting and caring for trees to enhance the sustainability of your landscape.',
        paragraphs: [
            'Trees are a vital part of any landscape, providing shade, improving air quality, and enhancing the overall aesthetic of your property. Our professional tree planting services ensure that the right trees are selected and planted with precision to thrive in your environment.',
            'Whether you’re looking to add ornamental trees for beauty or larger shade trees for functionality, our team is here to guide you through the process. From site selection to proper planting techniques, we ensure long-term growth and sustainability for your trees.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: {
            intro: 'Why choose our tree planting services?',
            list: [
                'Expert advice on tree selection',
                'Planting techniques for long-term growth',
                'Eco-friendly and sustainable practices',
                'Enhances the beauty and value of your property',
                'Promotes a healthier environment'
            ]
        },
        process: {
            intro: 'Our tree planting process is designed to ensure healthy growth.',
            list: [
                'Consultation to assess your property',
                'Recommendations for tree types based on your needs',
                'Site preparation and soil testing',
                'Careful planting for optimal growth',
                'Post-planting care and maintenance guidance'
            ]
        },
        faqs: [
            {
                id: 1,
                heading: 'How do I choose the right trees for my property?',
                content: 'Our team will assess your property and recommend trees that suit your landscape, soil type, and climate while meeting your aesthetic and functional goals.'
            },
            {
                id: 2,
                heading: 'Do you provide maintenance after planting?',
                content: 'While our service focuses on planting, we also offer guidance on tree care and can recommend ongoing maintenance services to ensure your trees thrive.'
            },
            {
                id: 3,
                heading: 'Can you plant mature trees?',
                content: 'Yes, we can plant mature trees, although this depends on accessibility and site conditions. We’ll discuss all options during the consultation.'
            },
            {
                id: 4,
                heading: 'What time of year is best for tree planting?',
                content: 'Tree planting is best done in early spring or fall when the weather is cooler and promotes root establishment. However, we can guide you based on local conditions.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4, 
        title: 'Hardscaping',
        content: 'Creating durable hardscape features such as patios, walkways, and retaining walls.',
        paragraphs: [
            'Hardscaping is the backbone of any well-designed outdoor space, offering structure, durability, and functionality. From patios and walkways to retaining walls and decorative stonework, our hardscaping services bring your vision to life with precision and artistry.',
            'Whether you’re looking for a sleek modern design or a more natural aesthetic, we ensure your outdoor features blend seamlessly with the surrounding landscape. Our team works with high-quality materials and cutting-edge techniques to deliver stunning, long-lasting results.'
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: {
            intro: 'Why choose our hardscaping services?',
            list: [
                'Custom designs tailored to your vision',
                'High-quality materials for durability',
                'Enhances outdoor functionality and style',
                'Expert craftsmanship for stunning results',
                'Low-maintenance solutions'
            ]
        },
        process: {
            intro: 'Our hardscaping process ensures a seamless and efficient project.',
            list: [
                'Consultation to understand your needs',
                'Customized design and material selection',
                'Site preparation for a solid foundation',
                'Precision installation by skilled professionals',
                'Final inspection and finishing touches'
            ]
        },
        faqs: [
            {
                id: 1,
                heading: 'What types of hardscaping projects do you handle?',
                content: 'We offer a wide range of hardscaping services, including patios, walkways, driveways, retaining walls, outdoor kitchens, and more.'
            },
            {
                id: 2,
                heading: 'How do you ensure durability in your hardscaping projects?',
                content: 'We use top-quality materials and proven installation techniques to ensure that your hardscaping features are built to last and withstand the elements.'
            },
            {
                id: 3,
                heading: 'Can you match existing hardscaping features?',
                content: 'Yes, we can blend new features with existing hardscaping to create a cohesive and seamless design that complements your space.'
            },
            {
                id: 4,
                heading: 'How long does a hardscaping project typically take?',
                content: 'The timeline depends on the scope and complexity of the project. We’ll provide an estimated timeline during the consultation phase.'
            }
        ]
    },
    {  
        id: 5,
        image: images.service5,
        title: 'Water Features',
        content: 'Designing and installing water features such as ponds, fountains, and waterfalls.',
        paragraphs: [
            'Water features create a serene and calming atmosphere in your garden. The gentle flow of water can drown out noise and create a peaceful retreat. From large ponds to small, decorative fountains, there are endless ways to incorporate water into your landscape design.',
            'Our team specializes in designing and installing custom water features that fit seamlessly into your garden. We ensure that the design complements your overall landscaping and meets your aesthetic preferences. Our installations are both visually striking and highly functional, making them the perfect addition to any garden.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2,
        ],
        features: {
            intro: 'Water features are the perfect way to transform your outdoor space with elegance and tranquility.',
            list: [
                'Adds a calming atmosphere to your garden',
                'Enhances the visual appeal of your landscape',
                'Promotes biodiversity by attracting wildlife',
                'Increases property value',
                'Low-maintenance options available'
            ]
        },
        process: {
            intro: 'We follow a simple yet effective process to bring your water feature vision to life.',
            list: [
                'Consultation to determine your needs and preferences',
                'Design of a custom water feature tailored to your garden',
                'Expert installation by our experienced team',
                'Ongoing maintenance and care to keep it looking great',
                'Complete satisfaction guaranteed'
            ]
        },
        faqs: [
            { 
                id: 1, 
                heading: 'How do we charge for water feature projects?',
                content: 'The cost of a water feature project depends on the size, complexity, and materials chosen. We provide a detailed estimate after assessing your space and discussing your requirements.',
            }, 
            { 
                id: 2,
                heading: 'Do we offer free consultations?',
                content: 'Yes, we offer free consultations to discuss your vision for the water feature, provide recommendations, and give you an accurate estimate.',
            },
            {
                id: 3, 
                heading: 'What types of water features do you install?',
                content: 'We specialize in installing fountains, ponds, waterfalls, and custom designs. Each project is tailored to your space and preferences.',
            },
            {
                id: 4,
                heading: 'Are water features difficult to maintain?',
                content: 'Most water features are low-maintenance, especially if you choose a design with an efficient filtration system. We provide ongoing maintenance services to ensure that your water feature remains in excellent condition.',
            },
        ]
    },
    {   
        id: 6, 
        image: images.service6, 
        title: 'Outdoor Lighting',
        content: "Installing elegant and energy-efficient lighting solutions to illuminate your garden.",
        paragraphs: [
            'Our outdoor lighting designs are aimed at creating a welcoming atmosphere for your garden or patio, with the added benefit of improved security. By strategically placing lights around your landscape, we can enhance features such as pathways, trees, and architectural elements.',
            'From subtle pathway lights to bold statement pieces, we offer a variety of lighting options to fit your needs. Our team ensures that the lights blend seamlessly with your landscape, highlighting its beauty while providing functionality and safety.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2,
        ],
        features: {
            intro: 'Illuminate your outdoor spaces and transform your garden into a night-time oasis with our custom outdoor lighting solutions.',
            list: [
                'Enhances the beauty of your garden at night',
                'Improves safety and security',
                'Creates ambiance for outdoor gatherings',
                'Energy-efficient LED lighting options',
                'Low-maintenance solutions'
            ]
        },
        process: {
            intro: 'Our process for designing and installing outdoor lighting is straightforward, ensuring the best results for your outdoor spaces.',
            list: [
                'Consultation to understand your lighting needs and preferences',
                'Custom lighting design tailored to your outdoor space',
                'Professional installation by our experienced team',
                'Ongoing support and maintenance to keep your lights in top condition',
                'Satisfaction guaranteed'
            ]
        },
        faqs: [
            { 
                id: 1, 
                heading: 'How much does outdoor lighting cost?',
                content: 'The cost of outdoor lighting depends on the scope of the project, the type of lighting chosen, and the size of your outdoor area. We provide detailed estimates based on your specific needs.',
            }, 
            { 
                id: 2,
                heading: 'Do you offer energy-efficient lighting?',
                content: 'Yes, we offer a range of energy-efficient LED lighting options that are both cost-effective and eco-friendly.',
            },
            {
                id: 3, 
                heading: 'Can you install lighting in existing gardens?',
                content: 'Absolutely! We can retrofit lighting into your existing garden or landscape, ensuring that it complements the features and enhances the beauty of your space.',
            },
            {
                id: 4,
                heading: 'Is outdoor lighting easy to maintain?',
                content: 'Our lighting solutions are designed to be low-maintenance, with durable fixtures and energy-efficient bulbs. We also offer maintenance services to ensure that your lights continue to perform at their best.',
            },
        ]
    }
];

export default services;